"use client";

import { useState } from "react";
import { Button } from "../ui/button";

export interface QuizItem {
  term: string;
  definition: string;
}

interface QuizProps {
  items: QuizItem[];
  title?: string;
}

export default function Quiz({ items, title }: QuizProps) {
  const [showAnswers, setShowAnswers] = useState(false);

  if (!items || items.length === 0) return null;

  return (
    <div className="my-6 border border-border rounded-lg p-4 bg-gray-50">
      {title && <p className="text-lg font-semibold mb-4">{title}</p>}

      <Button
        onClick={() => setShowAnswers(!showAnswers)}
        variant="primary"
        size="lg"
        className="mb-2"
      >
        {showAnswers ? "Hide Answers" : "Show Answers"}
      </Button>

      <ul className="space-y-3">
        {items.map((item, idx) => (
          <li key={idx}>
            <p className="font-semibold">{item.term}</p>
            {showAnswers && (
              <p className="ml-4 mt-1 text-gray-700">{item.definition}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
